<!--
    描述：项目信息
    日期：2022/9/19
    创建人：李家宝
-->
<template>
  <div class="box">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="项 目 登 记" name="1">
        <el-form label-width="150px" :show-message="false">
          <!--专家库使用单位信息-->
          <div class="zjxq_box">
            <div class="box_text">专家库使用单位信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="使用单位名称："
                  >{{ busProjectObj.tenantName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码："
                  >{{ busProjectObj.creditCode }}
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">-->
              <!--  <el-form-item label="操作人姓名：">{{-->
              <!--    busProjectDetailsObj.operator-->
              <!--  }}</el-form-item>-->
              <!--</el-col>-->
              <!--<el-col :span="12">-->
              <!--  <el-form-item label="操作人联系电话："-->
              <!--    >{{ busProjectDetailsObj.operatorPhone }}-->
              <!--  </el-form-item>-->
              <!--</el-col>-->
              <el-col :span="12">
                <el-form-item label="联系人：">{{
                  busProjectDetailsObj.contacter
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：">{{
                  busProjectDetailsObj.contacterPhone
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位类型：">{{
                  busProjectObj.flatTypeName
                }}</el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--项目信息-->
          <div class="zjxq_box">
            <div class="box_text" style="border-bottom: 0px">项目信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="项目名称："
                  >{{ project.sname }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目类型：">{{
                  project.proTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预算金额："
                  >{{ busProjectDetailsObj.budget }}万元</el-form-item
                >
              </el-col>
              <el-col :span="12">
                <el-form-item label="资金来源：">{{
                  busProjectDetailsObj.fondSourceName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易方式：">{{
                  busProjectDetailsObj.dealTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易组织方式：">{{
                  busProjectDetailsObj.organizeTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目所在区域："
                  >{{ busProjectDetailsObj.proAreaName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目详细地址："
                  >{{ busProjectDetailsObj.proAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公告发布时间："
                  >{{ busProjectDetailsObj.publishTime }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公告发布原文："
                  >{{ busProjectDetailsObj.noticeUrl }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--标段信息-->
          <div class="zjxq_box">
            <div class="box_text">标段信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评标地点："
                  >{{ busProjectObj.areaName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评标详细地址："
                  >{{ busProjectObj.bidAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开标时间："
                  >{{ project.openTime }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评标开始时间："
                  >{{ busProjectObj.startTime }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预估评标时长："
                  >{{ busProjectObj.estimateTimes }}小时</el-form-item
                >
              </el-col>
              <el-col :span="24">
                <el-table
                  class="mt10"
                  highlight-current-row
                  row-key="id"
                  border
                  ref="table"
                  :data="busProjectBidObj"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="sname"
                    label="标段名称"
                    min-width="180"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="codeName"
                    label="标段分类代码"
                    min-width="180"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="bidTypeName"
                    label="标段类型"
                    min-width="180"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="budget"
                    label="预算金额"
                    min-width="180"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row.budget }}万元
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
          <!--建设单位信息-->
          <div class="zjxq_box">
            <div class="box_text">建设单位信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="建设单位名称："
                  >{{ busProjectDetailsObj.consUnit }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码："
                  >{{ busProjectDetailsObj.consCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人姓名：">{{
                  busProjectDetailsObj.principal
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人联系电话："
                  >{{ busProjectDetailsObj.principalPhone }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位类型：">{{
                  busProjectDetailsObj.consUnitTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="项目附件：">
                  <div class="beyondHiding">
                    <div
                        v-for="(item, index) in busProjectFiles"
                        :key="index"
                        class="link mr10"
                        type="text"
                        @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                    >
                      <span slot="reference">{{ item.fileName }}</span>
<!--                      <el-popover
                          placement="top-start"
                          title="文件"
                          trigger="hover"
                      >
                        <div
                            v-for="e in busProjectFiles"
                            class="link"
                            :key="e.id"
                            @click="viewFile(e.fileDirectory + e.serverName)"
                        >
                          {{ e.fileName }}
                        </div>
                        <span slot="reference">{{ item.fileName }}</span>
                      </el-popover>-->
                    </div>
                  </div>

<!--                  <my-upload
                    ref="cns"
                    :aid="project.baseId"
                    :maxNum="1"
                    assortment="bus_project"
                    :tableName="'business_expand_zhuanjia'"
                    mode="view"
                    forDatabase="project_audit"
                    :isDisabled="true"
                  />-->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="zjxq_box" v-if="!isAudit" style="border: 1px solid #016CA4">
          <el-row>
            <el-col :span="8"> 创建人：{{ project.createUserName }} </el-col>
            <el-col :span="8"> 创建时间：{{ project.createDate }} </el-col>
            <el-col :span="8"> 抽取专家库：{{ project.libName }} </el-col>
          </el-row>
        </div>
        <div>
          <img
            v-if="project.status == '1009001004'"
            src="../../../../assets/images/project_end.png"
            alt="项目结束"
            title="项目结束"
            class="img"
          />
          <img
            src="../../../../assets/images/extracting.jpg"
            alt="待抽取"
            title="待抽取"
            v-if="project.status == '1009001003'"
            class="img"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import VUE_CONFIG from "../../../../../vue.config";
export default {
  name: "pro-beseinfo",
  props: {
    isAudit: {
      default: false
    },
    rowData: {
      type: Object
    },
    audit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeNames: ["1"],
      project: {},
      busProjectDetailsObj: {}, // 项目明细
      busProjectObj: {}, // 项目信息
      busProjectBidObj: [], // 标段信息
      busProjectFiles: []
    };
  },
  created() {
    this.busProjectDetailsObj = this.rowData.busProjectDetailsObj;
    this.busProjectObj = this.rowData.busProjectObj;
    this.project = this.rowData;
    this.busProjectBidObj = this.rowData.busProjectBidObj;
    this.busProjectFiles = this.rowData.sysFiles ? JSON.parse(this.rowData.sysFiles).filter(v => v.assortment == "bus_project") : [];
  },
  methods: {
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName);
    },
  }
};
</script>

<style scoped lang="less">
/deep/ .el-collapse-item__header {
  background: #eff6fe;
  font-weight: bolder;
  padding-left: 10px;
}

.box {
  position: relative;
  height: 100%;

  .footer {
    position: fixed;
    top: 88px;
    right: 135px;

    .el-button {
      height: 28px !important;
    }
  }

  .tips-warning,
  .tips-error {
    color: #f4650f;
    display: flex;
    align-items: center;
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
  }

  .tips-error {
    color: red;
  }

  .img {
    position: absolute;
    width: 118px;
    height: 90px;
    top: 256px;
    right: 187px;
  }

  .zjxq_box {
    padding: 10px 20px;
    margin-bottom: 10px;

    .box_text {
      font-weight: 500;
      border-bottom: 1px solid #f5f5f5;
      height: 30px;

      &:before {
        content: "";
        width: 3px;
        margin-right: 5px;
        height: 12px;
        background: #1f79ff;
        display: inline-block;
        vertical-align: central;
      }
    }

    .zjxq_box_item {
      display: inline-block;
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #f2f2f2;
      padding: 0 5px;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
